// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateCreditMemoReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetCreditMemoReport = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_CREDIT_MEMO_REPORT_SUCCESS]: updateCreditMemoReport,
        [actions.RESET_CREDIT_MEMO_REPORT]: resetCreditMemoReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/credit-memo/reducers/report.js